<template>
  <div>
    <el-table :data="AgentVerifyLogList" v-loading="loading">
      <el-table-column prop="id" width="100px" label="ID" />
      <el-table-column prop="admin_id" width="100px" label="admin_id" />
      <el-table-column prop="user_id" width="80px" label="user_id" />
      <el-table-column prop="time" width="120px" label="时间" />
      <el-table-column prop="status" width="150px" label="状态" :formatter="statusFormatter" />
      <el-table-column prop="additional" label="扩展信息" :formatter="additionalFormatter"/>
    </el-table>

    <page-bar :currentPageCount="AgentVerifyLogList.length" @page-changed="loadData"></page-bar>
  </div>
</template>

<style>
.content-left {
  text-align: left;
}
</style>
<script>
import PageBar from "../ui/PageBar";
import request from "../../api/request";

export default {
  name: "AgentVerifyLogList",
  components: {
    PageBar
  },
  data() {
    return {
      agentId: 0,
      AgentVerifyLogList: []
    };
  },
  created() {
    this.agentId = parseInt(this.$router.currentRoute.params["lid"]) || 0;
    request.agent
      .post("verify_get_log_list", {
        filter: { user_id: this.agentId },
        range: [0, 10]
      })
      .then(r => {
        this.AgentVerifyLogList = r.data.list;
        this.loading = false;
      });
  },
  methods: {
    statusFormatter(row, column, cellValue) {
      return ["待审核", "通过", "拒绝"][cellValue];
    },
    additionalFormatter(row, column, cellValue) {
      return JSON.stringify(cellValue);
    }
  }
};
</script>